import { pence } from '@cf/shared';
const SCHOOL_FEE_PROVENANCE = Object.freeze({
    source: 'Indicative UK independent-school market level proposed for firm sign-off (QUESTIONS.md #2) — not a quote for any school',
    asOf: '2026-07',
});
/** Proposed in QUESTIONS.md #2; adviser-editable per plan. */
export const SCHOOL_FEE_PRESETS = Object.freeze([
    Object.freeze({
        id: 'state',
        label: 'State school',
        feePerTerm: pence(0),
        provenance: SCHOOL_FEE_PROVENANCE,
    }),
    Object.freeze({
        id: 'prepDay',
        label: 'Prep day school',
        feePerTerm: pence(5_500_00),
        provenance: SCHOOL_FEE_PROVENANCE,
    }),
    Object.freeze({
        id: 'seniorDay',
        label: 'Senior day school',
        feePerTerm: pence(7_500_00),
        provenance: SCHOOL_FEE_PROVENANCE,
    }),
    Object.freeze({
        id: 'boarding',
        label: 'Boarding school',
        feePerTerm: pence(14_500_00),
        provenance: SCHOOL_FEE_PROVENANCE,
    }),
]);
const CARE_COST_PROVENANCE = Object.freeze({
    source: 'Indicative UK care-cost market level proposed for firm sign-off (QUESTIONS.md #4) — actual costs vary widely by region and provider',
    asOf: '2026-07',
});
/** Proposed in QUESTIONS.md #4; adviser-editable per plan. */
export const CARE_COST_PRESETS = Object.freeze([
    Object.freeze({
        id: 'domiciliary',
        label: 'Domiciliary (care at home)',
        annualCost: pence(25_000_00),
        provenance: CARE_COST_PROVENANCE,
    }),
    Object.freeze({
        id: 'residential',
        label: 'Residential care home',
        annualCost: pence(55_000_00),
        provenance: CARE_COST_PROVENANCE,
    }),
    Object.freeze({
        id: 'nursing',
        label: 'Nursing care home',
        annualCost: pence(75_000_00),
        provenance: CARE_COST_PROVENANCE,
    }),
]);
/**
 * Indicative university defaults (rUK tuition cap + a mid-range maintenance
 * figure), adviser-editable per plan. Proposed in QUESTIONS.md #4.
 */
export const UNIVERSITY_DEFAULTS = Object.freeze({
    annualTuition: pence(9_535_00),
    annualMaintenance: pence(10_000_00),
    durationYears: 3,
    provenance: Object.freeze({
        source: 'Tuition = the rUK undergraduate fee cap (GOV.UK); maintenance = an indicative mid-range living-cost figure proposed for firm sign-off (QUESTIONS.md #4)',
        asOf: '2026-07',
    }),
});
/** Pending until a named human signs the figures off (QUESTIONS.md #2/#4). */
export const EVENT_PRESETS_REVIEW = Object.freeze({
    reviewedBy: null,
    reviewedAt: null,
});
//# sourceMappingURL=event-presets.js.map